import Script from 'next/script';

interface GtmScriptProps {
  id: string;
  strategy: 'beforeInteractive' | 'afterInteractive';
  containerId: string;
  functionalCookiesEnabled: boolean;
}

export const GtmScript = ({ id, strategy, containerId, functionalCookiesEnabled }: GtmScriptProps) => {
  if (!functionalCookiesEnabled) {
    console.warn('GTM script is disabled because functional cookies are not enabled');
    return null;
  }

  return <Script id={id} strategy={strategy} dangerouslySetInnerHTML={{
    __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                                                                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                    })(window,document,'script','dataLayer','${containerId}');`,
  }} />;
};
